// extracted by mini-css-extract-plugin
export default {"Item":"AssigneePickerBase-module__Item--n9KU9"};